module.exports = __webpack_public_path__ + "assets/img/openai.2388b4c3.svg";